import {useLocation} from "@khan/urls";

/**
 * This is pretty simplistic right now, but it's much better than nothing.
 */
const css = `
body,
body .zoom-overlay,
body .perseus-video-widget {
    filter: hue-rotate(180deg) invert(1) brightness(1.1);
}
`;

/**
 * Injects our basic dark-mode css (inverting all the colors, basically)
 * if there is a `darkMode=1` query parameter.
 */
export const MobileDarkModeCSS = () => {
    const location = useLocation();
    if (location.queryParams.darkMode !== "1") {
        return null;
    }
    return <style>{css}</style>;
};
